'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfiniteLoader = undefined;

var _InfiniteLoader = require('./InfiniteLoader');

var _InfiniteLoader2 = _interopRequireDefault(_InfiniteLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InfiniteLoader2.default;
exports.InfiniteLoader = _InfiniteLoader2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/InfiniteLoader/index.js
// module id = 1715
// module chunks = 0